import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function Cancelado() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center px-6 text-center">
      <XCircle className="w-14 h-14 text-charcoal-500 mb-5" />
      <h1 className="font-serif text-4xl">Pagamento cancelado</h1>
      <p className="text-charcoal-700 mt-3 max-w-md">Nenhuma cobrança foi feita. Você pode retomar quando quiser — suas fotos não foram perdidas, é só recomeçar.</p>
      <div className="flex gap-3 mt-8">
        <Button onClick={() => navigate("/comecar")} data-testid="retry-checkout" className="rounded-full bg-charcoal-900 text-cream hover:bg-charcoal-700">Tentar novamente</Button>
        <Button onClick={() => navigate("/")} variant="outline" className="rounded-full">Voltar ao início</Button>
      </div>
    </div>
  );
}
